// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"712ee005","732":"4f832be7"}[chunkId] + ".chunk.js";
};